module.exports = __webpack_public_path__ + "img/transverse.9d94423c.svg";